var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_16021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12.8332C10.2216 12.8332 12.8333 10.2215 12.8333 6.99984C12.8333 3.77817 10.2216 1.1665 7 1.1665C3.77834 1.1665 1.16667 3.77817 1.16667 6.99984C1.16667 10.2215 3.77834 12.8332 7 12.8332Z",
    stroke: "#212129",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00455 6.12954C6.52132 6.12954 6.12955 6.52131 6.12955 7.00454C6.12955 7.48777 6.52132 7.87954 7.00455 7.87954C7.48778 7.87954 7.87955 7.48777 7.87955 7.00454C7.87955 6.52131 7.48778 6.12954 7.00455 6.12954ZM7.00455 6.12954V4.08252M8.75858 8.76131L7.62189 7.62462",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_16021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.48e2a0c576722425f06baa105d0ad3d3.svg";
export { ForwardRef as ReactComponent };